// ★ THIS TAB'S OWN WRITES, ANNOUNCED ONCE. The API client calls `announceApiWrite`
// on every successful POST / PATCH / DELETE to a tenant resource; a surface
// that must follow its own tab's writes wherever they come from (the sidebar's
// badge — mounted while every page comes and goes) subscribes here. The org
// channel will never tell such a surface: a tab drops the echo of its own
// writes (lib/socketId), on the rule that the tab that wrote knows the answer
// and the moment. This is that rule kept in ONE place, rather than one
// `badges.refetch()` after each of the thirty-odd write calls that can move a
// badge — a list the next write would forget to join.
//
// A plain module, no imports: the client calls in and composables listen,
// so neither side imports the other.

type ApiWriteListener = (resource: string) => void

const listeners = new Set<ApiWriteListener>()

/** The resource a tenant write landed on — `/api/jobs/j1` → `jobs`; anything
 *  else (a read, the identity flow) → null. */
export function writtenResource(method: string | undefined, url: string | undefined): string | null {
  if (!method || !url || ![ 'post', 'patch', 'delete' ].includes(method.toLowerCase())) return null
  return /^\/api\/([a-z_]+)(?:[/?]|$)/.exec(url)?.[1] ?? null
}

export function announceApiWrite(method: string | undefined, url: string | undefined): void {
  const resource = writtenResource(method, url)
  if (resource) listeners.forEach(listener => listener(resource))
}

/** Subscribe; returns the unsubscribe. */
export function onApiWrite(listener: ApiWriteListener): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
